import styled from '@emotion/styled';

export const SettingsLabel = styled.p`
    margin: 0;
    ${({ theme }) => theme.font.familySemiBold};
    font-size: ${({ theme }) => theme.size.textSmall};
    color: ${({ theme }) => theme.color.evilBlack};
`;
